<template>
    <div class="qingwu">
        <div class="admin_main_block">
            <div class="admin_main_block_top">
                <div class="admin_main_block_left">
                    <div><el-input v-model="where.phone" placeholder="请输入用户手机号"></el-input></div>
                    <div><el-button icon="el-icon-search" @click="get_logout_list()">条件筛选</el-button></div>
                </div>
            </div>

            <div class="admin_table_main">
                <el-table :data="list" @selection-change="handleSelectionChange" >
                    <el-table-column type="selection"></el-table-column>
                    <el-table-column prop="id" label="#" fixed="left" width="70px"></el-table-column>
                    <el-table-column prop="F_VR_NIC" label="用户昵称">
                        <template slot-scope="scope">
                            <dl class="table_dl">
                                <dt>
                                    <el-popover placement="left" trigger="click" width="600">
                                        <img :src="scope.row.F_VR_TOUX||require('@/assets/default_pic.png')" width="100%" />
                                        <img
                                                slot="reference"
                                                :src="scope.row.F_VR_TOUX||require('@/assets/default_pic.png')"
                                                :alt="scope.row.F_VR_TOUX"
                                                style="max-height: 50px;max-width: 50px; padding: 5px"
                                        />
                                    </el-popover>
                                    </dt>
                                <dd class="table_dl_dd_all_30">昵称： {{ scope.row.F_VR_NIC }}</dd>
                                <dd class="table_dl_dd_all_16_gray">注册时间： {{ scope.row.login_time|formatDate}}</dd>
                            </dl>
                        </template>
                    </el-table-column>
                    <el-table-column prop="phone" label="手机号码"></el-table-column>
                    <el-table-column prop="add_time" label="申请注销时间">
                      <template slot-scope="scope">{{ scope.row.add_time|formatDate}}</template>
                    </el-table-column>
                    <el-table-column prop="remark_time" label="审核时间">
                      <template slot-scope="scope">
                        <div v-if="scope.row.remark_time<=0"> - </div>
                        <div v-else>{{scope.row.remark_time|formatDate}}</div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="status_desc" label="审核状态"></el-table-column>
                    <el-table-column prop="sms_desc" label="短信通知"></el-table-column>
                    <el-table-column prop="remark" label="备注"></el-table-column>
                    <el-table-column label="操作" fixed="right" width="220px">
                        <template slot-scope="scope">
                            <el-button icon="el-icon-edit" @click="$router.push({name:'logout_form',params:{id:scope.row.user_id}})">处理</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="admin_table_main_pagination">
                    <el-pagination @current-change="current_change" background layout="prev, pager, next,jumper,total" :total="total_data" :page-size="page_size" :current-page="current_page"></el-pagination>
                </div>
            </div>
        </div>

        <el-dialog title="提示" :visible.sync="dialogVisible" width="50%">
            <ul class="logout_list_ul">
                <li>
                    <h4>昵称:</h4>{{info.nickname|'-'}}
                </li>
                <li>
                    <h4>头像:</h4><el-image style="width: 60px; height: 60px" :src="info.logout_logo"></el-image>
                </li>
                <!--<li>
                    <h4>入驻公司:</h4>{{info.logout_company_name|'-'}}-{{info.area_info}}-{{info.logout_address}}
                </li>
                <li>
                    <h4>营业执照号码:</h4>{{info.legal_person|'-'}}-{{info.business_license_no|'-'}}
                </li>-->
                <li>
                    <h4>身份证:</h4><el-image :preview-src-list="read_pic(info.business_license)" style="width: 60px; height: 60px" :src="info.business_license"></el-image>-<el-image :preview-src-list="read_pic(info.id_card)" style="width: 60px; height: 60px" :src="info.id_card"></el-image>
                </li>

                <li>
                    <h4>身份证号码:</h4>{{info.id_card_no|'-'}}
                </li>
                <li>
                    <h4>手机号:</h4><!--{{info.emergency_contact}}- -->{{info.emergency_contact_phone}}
                </li>
                <li>
                    <h4>备注:</h4><el-input type="textarea" placeholder="注销原因！" v-model="info.logout_close_info"></el-input>
                </li>
                <li>
                    <h4>注销审核:</h4>
                    <el-radio v-model="logout_verify" :label="0">等待审核(忽略)</el-radio>
                    <el-radio v-model="logout_verify" :label="1">同意</el-radio>
                    <el-radio v-model="logout_verify" :label="2">拒绝</el-radio>
                </li>

            </ul>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">关 闭</el-button>
                <el-button type="primary" @click="update_logout()">确 定</el-button>
            </span>
            </el-dialog>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
      return {
          list:[],
          total_data:0, // 总条数
          page_size:20,
          current_page:1,
          select_id:'',
          dialogVisible:false,
          info:{},
          logout_verify:0,
          where:{
              times:[],
              phone:''
          },
      };
    },
    watch: {},
    computed: {},
    methods: {
        handleSelectionChange:function(e){
            let ids = [];
            e.forEach(v => {
                ids.push(v.id);
            });
            this.select_id = ids.join(',');
        },
        get_logout_list:function(){
            let where = {};
            where.page = this.current_page;
            where.params = this.where;
            this.$get(this.$api.getLogoutList,where).then(res=>{
                this.page_size = res.data.per_page;
                this.total_data = res.data.total;
                this.list = res.data.data;
                this.current_page = res.data.current_page;
            })
        },
        read_logout_info(e){
            this.info = e;
            this.logout_verify = this.info.logout_verify;
            this.dialogVisible=true;
        },
        read_pic(e){
            return [e];
        },
        update_logout:function(){
            if(this.info.logout_status==0 && this.info.logout_close_info == ''){
                return this.$message.error('请填写关闭店铺的原因！');
            }
            this.info.logout_verify = this.logout_verify;
            this.$post(this.$api.getStoreList,this.info).then(res=>{
                this.$message.success('修改成功');
                this.dialogVisible = false;
                this.get_logout_list();
            });
        },
        // 分页改变
        current_change:function(e){
            this.current_page = e;
            this.get_logout_list();
        },
        // 删除处理
        del:function(id){
            let _this = this;
            if(this.$isEmpty(id)){
                return this.$message.error('请先选择删除的对象');
            }
            this.$post(this.$api.delLogout,{id:id}).then(function(res){
                if(res.code == 200){
                    _this.get_logout_list();
                    return _this.$message.success("删除成功");
                }else{
                    return _this.$message.error("删除失败！"+res.msg);
                }
            });
        },
        // 指定ID修改状态
        state_status:function(id){
            this.$post(this.$api.stateLogouttStatus,{id:id}).then(res=>{
                if(res.code==200){
                    this.$message.success('操作成功');
                }else{
                    this.$message.success('操作失败');
                }
                this.get_logout_list();
            });
        },
        // 指定ID修改状态
        huiy_status:function(id){
            this.$post(this.$api.huiyLogouttStatus,{id:id}).then(res=>{
                if(res.code==200){
                    this.$message.success('操作成功');
                }else{
                    this.$message.success('操作失败');
                }
                this.get_logout_list();
            });
        },
        // 指定ID修改状态
        sviphy_status:function(id){
            this.$post(this.$api.sviphyLogouttStatus,{id:id}).then(res=>{
                if(res.code==200){
                    this.$message.success('操作成功');
                }else{
                    this.$message.success('操作失败');
                }
                this.get_logout_list();
            });
        }
    },
    created() {
        this.get_logout_list();
    },
    mounted() {}
};
</script>
<style lang="scss" scoped>
.logout_list_ul li{
    border-bottom: 1px solid #efefef;
    margin:0 0 30px 0;
    padding-bottom: 15px;
    color:#666;
    h4{
        margin-bottom: 15px;
        color:#333;
    }
}
</style>